<template>
  <generic-update-list
    v-bind="{ model, modelHeaders, modelFk, defaultItem }"
    custom-export-url="/show-hotels/export/"
    has-availabilities
  >
    <template v-slot:form="{ editedItem, error }">
      <v-row>
        <v-col cols="12" sm="4">
          <autocomplete
            v-model="editedItem.hotel"
            :error-messages="error.hotel"
            :model="hotelModel"
            item-text="name"
            item-value="id"
            label="Hotel"
          ></autocomplete>
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
            v-model="editedItem.status"
            :error-messages="error.status"
            :items="[
              { value: 1, text: 'selezionato' },
              { value: 2, text: 'contattato' },
              { value: 3, text: 'approvato' },
            ]"
            label="Stato"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.referent_name"
            :error-messages="error.referent_name"
            label="Referente"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.referent_phone"
            :error-messages="error.referent_phone"
            label="Contatto"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.notes"
            :error-messages="error.notes"
            label="Note"
          ></v-text-field>
        </v-col>
      </v-row>
      <ul v-if="editedItem.warnings && editedItem.warnings.length > 0">
        <li
          v-for="warning in editedItem.warnings"
          :key="warning"
          class="red--text"
        >
          <template v-if="warning.type == 'hotel_missing_referent'">
            Hotel senza referente interno
          </template>
        </li>
      </ul>
    </template>

    <template v-slot:item.status="{ item }">
      <status-indicator small :status="item.status" />
    </template>

    <template v-slot:item.export="{ item }">
      <router-link
        :to="{
          name: 'ExportHotels',
          params: { id: modelFk.show, hotelId: item.id },
        }"
      >
        Esporta
      </router-link>
    </template>

    <template v-slot:item.warnings="{ item }">
      <v-icon v-if="item.warnings.length > 0">
        fa fa-exclamation-triangle
      </v-icon>
    </template>
  </generic-update-list>
</template>

<script>
import models from "@/models"
import statuses from "@/statuses"

export default {
  data() {
    return {
      modelHeaders: [
        { text: "Hotel", value: "hotel__name" },
        { text: "Stato", value: "status" },
        { text: "Alert", value: "warnings" },
      ],
      model: models.ShowHotel,
      hotelModel: models.Hotel,
      statuses,
    }
  },
  computed: {
    modelFk() {
      return { show: this.$route.params.id }
    },
  },
  methods: {
    defaultItem: () => ({
      availabilities: [],
      hotel: null,
      referent_name: "",
      referent_phone: "",
      notes: "",
    }),
  },
}
</script>
